<template>
    <div class="exception-body notfound">
        <div class="exception-content">
            <div class="exception-title">{{$t('common.not_found.title')}}</div>
            <div class="exception-detail">{{$t('common.not_found.detail')}}</div>
            <!-- <router-link to="/">{{$t('common.not_found.link')}}</router-link> -->
        </div>
    </div>
</template>

<script>
export default {};
</script>